import classNames from 'classnames';
import React from 'react';
import './Select.scss';
import ISelectProps from './SelectProps';

function Select({
  onChange,
  options,
  value = '',
  hasArrow = true,
  onFocus,
  onBlur,
  onKeyDown,
  onClick,
  error = false,
  disabled = false,
  placeholder = 'Select...',
  selectRef,
  autofocus,
  className,
}: ISelectProps) {
  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    if (!disabled) {
      onChange(event.target.value, event);
    }
  }

  function handleClick(event: React.MouseEvent<HTMLSelectElement>) {
    if (!disabled && onClick) {
      onClick(event.currentTarget.value, event);
    }
  }

  function handleFocus(event: React.FocusEvent) {
    if (!disabled && onFocus) {
      onFocus(event);
    }
  }

  function handleBlur(event: React.FocusEvent) {
    if (!disabled && onBlur) {
      onBlur(event);
    }
  }

  function handleOnKeyDown(event: React.KeyboardEvent) {
    if (!disabled && onKeyDown) {
      onKeyDown(event);
    }
  }

  function renderOptions() {
    const selectOptions = options.map((option, index) => {
      return (
        <option key={index + 1} value={option.value} disabled={disabled}>
          {option.label}
        </option>
      );
    });

    if (!value) {
      const selectPlaceholder = (
        <option disabled={disabled} key={0} value="">
          {placeholder}
        </option>
      );
      selectOptions.unshift(selectPlaceholder);
    }

    return selectOptions;
  }

  const inputClasses = classNames({
    disabled,
    'select-error': error,
    'has-arrow': hasArrow,
  });

  return (
    <div className={classNames('select-shell', className)}>
      <select
        className={inputClasses}
        disabled={disabled}
        value={value}
        onChange={handleChange}
        onClick={handleClick}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleOnKeyDown}
        ref={selectRef}
        autoFocus={autofocus ? true : false}
      >
        {renderOptions()}
      </select>
    </div>
  );
}

export default Select;
